<template>
  <div v-for="(qualification, index) in qualifications" class="form-group" :key="index">
    <div class="input-group">
      <input class="form-control" type="text" :name="`qualifications[${index}][title]`" v-model="qualification.title">
      <input type="date" class="form-control" :name="`qualifications[${index}][qualified_at]`" v-model="qualification.qualifiedAt">
      <div class="input-group-append">
        <button class="btn btn-sm btn-light border" type="button" @click="removeQualification(index)">
          <i class="fas fa-times" />
        </button>
      </div>
    </div>
  </div>

  <br v-if="qualifications.length === 0">
  <!-- 追加ボタン-->
  <button class="mt-1 btn btn-sm btn-light border" type="button" @click="addQualification">
    <i class="fas fa-plus" />
  </button>
</template>

<script>
import Qualification from "../../../models/Qualification";

export default {
  props: {
    initialQualifications: {
      type: Array,
      required: true,
    }
  },

  mounted() {
    this.qualifications = this.initialQualifications.map(e => new Qualification(e));
  },

  data() {
    return {
      qualifications: [],
    }
  },

  methods: {
    addQualification() {
      this.qualifications.push(new Qualification({title: '', qualified_at: ''}));
    },

    removeQualification(index) {
      this.qualifications.splice(index, 1);
    },
  }

}
</script>
